import React from 'react';
import PropTypes from 'prop-types';
import styles from './BillingCard.css';
import { SecondaryButton } from '../../../common/secondary-button';
import { BILLING_DATA_TYPES } from '../../../models/BillingData';

const IPropTypes = {
  billing: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    address: PropTypes.string,
    rut: PropTypes.string,
    personalId: PropTypes.string,
    locality: PropTypes.string,
    department: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

const defaultProps = {
  disabled: false,
  onClick: () => {},
};

const BillingCard = props => (
  <div className={styles.container}>
    <p className={styles.name}>
      {props.billing.name}
    </p>
    <p className={styles.address}>
      {props.billing.address}
    </p>
    <p className={styles.localityDepartment}>
      {`${props.billing.locality}, ${props.billing.department}`}
    </p>
    {
      props.billing.type === BILLING_DATA_TYPES.RUT &&
      <p className={styles.rutOrPersonalId}>
        {`RUT: ${props.billing.rut}`}
      </p>
    }
    {
      props.billing.type !== BILLING_DATA_TYPES.RUT &&
      <p className={styles.rutOrPersonalId}>
        {`Documento: ${props.billing.personalId}`}
      </p>
    }
    <SecondaryButton
      className={styles.editBillingData}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      Seleccionar
    </SecondaryButton>
  </div>
);

BillingCard.propTypes = IPropTypes;
BillingCard.defaultProps = defaultProps;

export { BillingCard };



// WEBPACK FOOTER //
// ./src/pages/payment-methods-and-billing/billing-card/BillingCard.jsx